import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const NotLoggedInBanner = () => (
  <div className="banner-wrapper">
    <StaticImage
      src={"../../../assets/images/games/logout-game-banner.jpg"}
      alt="Log in to play"
      placeholder="blurred"
      width={1240}
      quality={100}
    />
  </div>
);

export default NotLoggedInBanner;
